/**
 * import alert from './alerts.js'
 *
 * Usage
 *
 * new alert().session()
 * // This is for laravel messages, call it in app.js
 *
 * new alert().response()
 * // This is for js messages.
 * // Params
 * // type = 'error' or 'success'
 * // response = string or Array
 *
 * new alert().custom()
 * // This is for js messages.
 * // Params
 * // type = 'error' or 'success'
 * // response = object eg. { title: string, content: string or Array }
 *
 * new alert().confirm()
 * // This is for html messages, , call it in app.js

 * // Example <a>
 * <a
 * alert="confirm-link"
 * alert-title="Lorem"
 * alert-content="Lorem ipsum dolor"
 * alert-continue="Continue"
 * alert-cancel="Cancel"
 * ></a>

 * // Example <form>
 * <button type="submit"
 * alert="confirm-form"
 * alert-title="Lorem"
 * alert-content="Lorem ipsum dolor"
 * alert-continue="Continue"
 * alert-cancel="Cancel"
 * ></button>
 */


require('jquery-confirm')

const __ = {
  'en': {
    'cancel':    'Cancel',
    'close':     'Close',
    'continue':  'Continue',
    'title': {
      'success': 'Completed',
      'error':   'Something is wrong'
    }
  },
  'es': {
    'cancel':    'Cancelar',
    'close':     'Cerrar',
    'continue':  'Continuar',
    'title': {
      'success': 'Completado',
      'error':   'Hay un problema'
    }
  }
}
const settings = {
  animation        : 'scale',
  backgroundDismiss: true,
  closeAnimation   : 'scale',
  smoothContent    : false,
  theme            : 'modern',
  typeAnimated     : false,
  useBootstrap     : false
}
const defaultButtons = {
  buttons: {
    close: {
      btnClass: 'btn--alert-close',
      text: '<i class="x:fs-18 fas fa-times"></i>'
    },
    btnClose: {
      btnClass: 'btn btn--orange btn--large',
      text: `<span>${__[app.locale].close}</span>`,
    },
  }
}

const errorAlert = (response) => {
  let content = (response.constructor === Array) ? '<ul><li>' + response.join('</li><li>') + '</li></ul>' : response
  let options = {
    title  : `<span class="c-main-green">${'<i class="fas fa-times-circle x:fs-34 x:mrg-right-10 dis-inline-block x:middle"></i>'} <span class="dis-inline-block x:middle">${__[app.locale].title.error}</span></span>`,
    content: content,
    icon   : 'far fa-times-circle x:fs-40',
    type   : 'red',
  }

  options = $.extend(settings, options, defaultButtons)

  $.confirm(options)
}
const successAlert = (message) => {
  let content = (message.constructor === Array) ? '<ul><li>' + message.join('</li><li>') + '</li></ul>' : '<p>' + message + '</p>'
  let options = {
    title  : `${'<i class="fas fa-check-circle x:fs-34 x:mrg-right-10 dis-inline-block x:middle"></i>'} <span class="dis-inline-block x:middle">${__[app.locale].title.success}</span>`,
    content: content,
    icon   : 'far fa-check-circle x:fs-50',
    type   : 'green',
  }

  options = $.extend(settings, options, defaultButtons)

  $.confirm(options)
}
const customAlert = (type, response) => {
  let content = (response.content.constructor === Array) ? '<ul><li>' + response.content.join('</li><li>') + '</li></ul>' : response.content
  let options = {
    content: content,
    title  : `<i class="fas ${type === 'success' ? 'fa-check-circle' : 'fa-times-circle'} x:fs-34 x:mrg-right-10 dis-inline-block x:middle"></i> <span class="dis-inline-block x:middle">${response.title}</span>`,
    type   : (type === 'success') ? 'green' : 'red',
  }

  options = $.extend(settings, options, defaultButtons)

  $.confirm(options)
}
const confirmAlert = ($alert) => {
  const btnDefaultClass = 'btn btn--large x:mrg-bt-5'
  const currentEmail = $alert.getAttribute('alert-current-email')
  const emailInput = document.getElementById($alert.getAttribute('alert-email-input'))
  let content = $alert.getAttribute('alert-content') || ''

  if (currentEmail && emailInput) {
    content = $('<div>').text(`¿Está seguro que desea cambiar el email del usuario ${currentEmail} a ${emailInput.value}?`).html()
  }

  let options = {
    title  : $alert.getAttribute('alert-title')   || '',
    content,
    type   : 'neutral',
    buttons: {
      cancel: {
        btnClass: 'btn btn--black-o btn--large',
        text: '<div>' + $alert.getAttribute('alert-cancel') || __[app.locale].cancel + '</div>',
      },
      confirm: {
        btnClass: 'btn btn--orange btn--large',
        text: '<div>' + $alert.getAttribute('alert-continue') || __[app.locale].continue + '</div>',
        action: function() {
          if ($alert.getAttribute('alert') === 'confirm-form') {
            $alert.closest('form').submit()
          }
          if ($alert.getAttribute('alert') === 'confirm-link') {
            window.location.href = $alert.getAttribute('href')
          }
          if ($alert.getAttribute('alert') === 'confirm-custom') {
            const onConfirm = eval($alert.getAttribute('onConfirm'))
            onConfirm ? onConfirm() : null
          }
        }
      },
      close: {
        btnClass: 'btn--alert-close',
        text: '<i class="x:fs-18 fas fa-times"></i>'
      },
    },
  }

  options = $.extend(settings, options)

  $.confirm(options)
}

class alert {
  constructor() {
    this.dom = {
      alerts: document.querySelectorAll('[alert]')
    }
  }
  session() {
    if (app.errors.length > 0)
      errorAlert(app.errors)

    if (app.success.length > 0)
      successAlert(app.success)
  }
  response(type = null, response = null) {
    if (type === 'error')
      errorAlert(response)

    if (type === 'success')
      successAlert(response)
  }
  custom(type = null, response = {}) {
    if (Object.keys(response).length === 0)
      return false

    customAlert(type, response)
  }
  confirm(alert) {
    if (!this.dom.alerts.length > 0)
      return false

    if(alert) {
      alert.addEventListener('click', (e) => {
        e.preventDefault()

        const form = e.currentTarget.closest('form')
        if (e.currentTarget.getAttribute('alert') === 'confirm-form' && form && form.checkValidity && !form.checkValidity()) {
          if (form.reportValidity)
            form.reportValidity()

          return
        }

        confirmAlert(e.currentTarget)
      })
    } else {
      this.dom.alerts.forEach(($alert) => {
        $alert.addEventListener('click', (e) => {
          e.preventDefault()

          const form = e.currentTarget.closest('form')
          if (e.currentTarget.getAttribute('alert') === 'confirm-form' && form && form.checkValidity && !form.checkValidity()) {
            if (form.reportValidity)
              form.reportValidity()

            return
          }

          confirmAlert(e.currentTarget)
        })
      })
    }
  }
}

export default alert
